import Vue from 'vue'
import { PageHeader, Form, Input, Select, Button, message, Spin, Modal, Descriptions } from 'ant-design-vue'
import ImgCaptcha from '@/components/imgcaptcha'

Vue.use(PageHeader)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Spin)
Vue.use(Descriptions)
Vue.use(ImgCaptcha)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
